/** Accept only a real cancer-catalog payload. HTML and empty bodies are not a catalog. */

const RARE_CATEGORIES = ['ultra-rare', 'very-rare', 'rare'];
const COMMON_CATEGORIES = ['common', 'less-common'];

function isCard(item) {
  return Boolean(item && typeof item === 'object' && String(item.name || '').trim());
}

function cards(value) {
  if (!Array.isArray(value)) return [];
  return value.filter(isCard);
}

export function catalogLists(data) {
  if (!data || typeof data !== 'object') return null;

  if (Array.isArray(data)) {
    const rows = cards(data);
    if (!rows.length) return null;
    return {
      rare: rows.filter((row) => RARE_CATEGORIES.includes(row.category)),
      common: rows.filter((row) => COMMON_CATEGORIES.includes(row.category)),
      counts: null,
    };
  }

  const rare = cards(data.rare_cancers);
  const common = cards(data.common_cancers);
  if (!rare.length && !common.length) return null;
  const counts = data.counts && typeof data.counts === 'object' ? data.counts : null;
  return { rare, common, counts };
}
